export default __webpack_public_path__ + "static/media/tulips.ba1e0e66.jpeg";